import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// 🧠 External handler for submission logic
const submitAnswerHandler = async ({ answer, setLoading, onSubmit, onClose }) => {
  if (!answer.trim()) return;
  setLoading(true);
  try {
    await onSubmit(answer);
  } finally {
    setLoading(false);
    onClose();
  }
};

const SolveModal = ({ isOpen, onClose, onSubmit, questTitle, questContext }) => {
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Blurred Background */}
          <div
            className="absolute inset-0 bg-black/30 backdrop-blur-sm"
            onClick={onClose}
          />

          {/* Modal Card */}
          <motion.div
            className="relative z-10 w-full max-w-md bg-white rounded-3xl shadow-xl p-6 overflow-y-auto max-h-[90vh]"
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.92 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-bold text-center text-black mb-2 font-inter">
              Solve Quest
            </h2>

            <p className="text-center text-gray-600 text-sm font-inter mb-3">
              <strong>{questTitle}</strong>
            </p>
            <p className="text-sm text-gray-500 font-inter text-center mb-5 px-2 whitespace-pre-wrap">
              {questContext}
            </p>

            {/* Answer Input */}
            <textarea
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              rows={5}
              className="w-full rounded-xl p-3 border border-gray-300 focus:outline-none focus:ring-2 
                         focus:ring-black resize-none transition-all font-inter text-sm"
              placeholder="Type your answer here with love and logic 💭"
            />

            {/* Buttons */}
            <div className="mt-6 flex justify-between items-center">
              <button
                onClick={onClose}
                className="text-sm text-gray-500 hover:text-black transition-all font-inter"
              >
                Cancel
              </button>

              <button
                onClick={() =>
                  submitAnswerHandler({ answer, setLoading, onSubmit, onClose })
                }
                disabled={loading || !answer.trim()}
                className={`px-6 py-2 rounded-full bg-black text-white text-sm font-semibold font-inter 
                           hover:bg-neutral-800 transition-all active:scale-95 
                           ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                {loading ? "Grading..." : "Submit Answer"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SolveModal;
